export default __webpack_public_path__ + "static/media/Logo_Dtt.2821c6c8.png";